import React from "react";
import { useTranslation } from "react-i18next";
import { Button as MuiButton, ButtonProps as MuiButtonProps } from "@mui/material";

export interface ButtonProps extends MuiButtonProps {
    text?: string | null | undefined;
    tx?: string;
    txOptions?: object;
}

export const Button = (props: ButtonProps) => {
    const { tx, txOptions, text, children, ...rest } = props;

    const { t } = useTranslation();

    // @ts-expect-error tx err
    const translated = tx && t(tx, txOptions);
    const content = translated || text || children;

    return (
        <MuiButton disableElevation {...rest}>
            {content}
        </MuiButton>
    );
};
